module.exports = __webpack_public_path__ + "static/header-image-premium-care-6ea4048dce7d078c6701a35282d00c1d.jpg";